import { UiNotification, UiNotificationType } from '@infuse/ui/domain';
import { useEmitter } from './ui-emitter';
import { PartialBy } from '@infuse/utils';

let count = 0;

export const useNotify = () => {
  const emitter = useEmitter();

  const generateId = () => {
    return count++;
  };

  function notify(notification: PartialBy<UiNotification, 'group' | 'type'>) {
    notification.id = generateId();
    notification.group = notification.group || 'notify-top';
    notification.type = notification.type || UiNotificationType.SUCCESS;
    emitter.emit('notify', { notification });
  }

  return notify;
};
